import { channelNames } from '../../../constants/common';
import { accountInfo, channelNameKeys } from '../../../interfaces/common';

export async function getAllCategoryAccounts(sessionId: string) {
  if (!sessionId || sessionId === '') return;

  return await fetch(`${process.env.REACT_APP_API_PATH}/connections`, {
    headers: {
      'x-session-id': sessionId,
    },
  })
    .then(async (response) => {
      if (response.status === 200) {
        let json: accountInfo[] = await response.json();
        json = json.map((connection) => {
          const platform =
            (connection.sdkPlatform as channelNameKeys) ||
            (connection.isCustomerSimulator && ('agent_trainer' as channelNameKeys)) ||
            (connection.platform as channelNameKeys);
          connection.standardPlatformName = channelNames[platform];
          return connection;
        });
        return {
          data: json,
          status: 200,
        };
      } else if (response.status === 403) {
        return {
          errorMessage: 'Invalid or expired session.',
          status: response.status,
        };
      } else {
        return {
          errorMessage: 'Failed to get list of accounts.',
          status: response.status,
        };
      }
    })
    .catch((error) => {
      console.error('Error:', error);
      return {
        errorMessage: 'Failed to get list of accounts.',
        status: null,
      };
    });
}
